export default __webpack_public_path__ + "static/media/obstacle-shadow.91c89258.png";